import CIMSTextArea from 'components/CIMSTextArea'
import { HelpMessage } from 'utils/constants'
import { FormItemProps } from '../types'
import CIMSFormItem from 'components/CIMSFormItem'
import { IssueStatus } from '@cims-online/shared'

const Description: React.VFC<Pick<FormItemProps, 'to'>> = ({ to }) => {
  return (
    <CIMSFormItem
      name="description"
      label="Description"
      requiredMessage={to === IssueStatus.Draft.id ? undefined : true}
      help={HelpMessage.Issues.IssueTracker.Description}
    >
      <CIMSTextArea maxLength={2000} />
    </CIMSFormItem>
  )
}

export default Description
